module.exports = __webpack_public_path__ + "img/poster-qrc-channel.459b34be.jpg";